export default __webpack_public_path__ + "static/media/icn-aguardando-ciencia.a4e66521.svg";